const ope = {
  state: {
    module: '',
    title: '',
    header: '',
    headName: '',
    type: '',
    typeName: '',
    kind: '',
    kindName: '',
    channel: '',
    channelName: '',
    quota: '',
    quotaName: '',
    time: '2',
    timeName: '月',
    yearTime: '',
    monthTime: '',
    currentData: '',
    tabletype: null, // 1是产品分析  2是结构分析
    pageFlag: null,
    careDesc: '', //  关注的描述
    pathId: '', //  关注调整条件
    calendarDate: '', //  详情页传递的日历
    class2Active: 0, // 个险第二个分类变量
    detailChannel: '',
    channelQuota: [],
    areaCode: '',
    areaFlag: ''
  },
  mutations: {
    // 运营指标页头部渠道id
    OPE_SET_HEADER: (state, type) => {
      state.header = type
    },
    // 运营指标页头部预收指标 考核指标id
    OPE_SET_TYPE: (state, type) => {
      state.type = type
    },
    // 运营指标页头部类型id
    OPE_SET_KIND: (state, type) => {
      state.kind = type
    },
    // 运营指标卡片id
    OPE_SET_QUOTA: (state, type) => {
      state.quota = type
    },
    // 运营指标详情页头部渠道id
    OPE_SET_CHANNEL: (state, type) => {
      state.channel = type
    },
    // 运营指标详情页渠道名称
    OPE_SET_CHANNEL_NAME: (state, type) => {
      state.channelName = type
    },
    // 运营指标页头部渠道名称
    OPE_SET_HEADER_NAME: (state, type) => {
      state.headName = type
    },
    // 运营指标页预收指标  考核指标名称
    OPE_SET_TYPE_NAME: (state, type) => {
      state.typeName = type
    },
    // 运营指标页类型名称
    OPE_SET_KIND_NAME: (state, type) => {
      state.kindName = type
    },
    // 运营指标卡片名称
    OPE_SET_QUOTA_NAME: (state, type) => {
      state.quotaName = type
    },
    // 运营时间类型   1日  2月  3年
    OPE_SET_TIME: (state, type) => {
      state.time = type
    },
    // 运营指标详情页时间类型名称  日  月  年
    OPE_SET_TIME_NAME: (state, type) => {
      state.timeName = type
    },
    // 获取运营指标详情页默认传入的年份
    OPE_SET_YEAR_TIME: (state, type) => {
      state.yearTime = type
    },
    // 获取运营指标详情页默认传入的月份
    OPE_SET_MONTH_TIME: (state, type) => {
      state.monthTime = type
    },
    // 获取运行指标详情页默认传入日期
    OPE_SET_CURRENT_TIME: (state, type) => {
      state.currentData = type
    },
    // 运营指标详情页表格类型
    OPE_SET_TABLETYPE: (state, type) => {
      state.tabletype = type
    },
    // 判断是否为指标详情页
    OPE_SET_PAGEFLAG: (state, type) => {
      state.pageFlag = type
    },
    // 跳转详情页描述
    OPE_SET_CAREDESC: (state, type) => {
      state.careDesc = type
    },
    // 详情页判断指标
    OPE_SET_PATHID: (state, type) => {
      state.pathId = type
    },
    // 详情页日历选择的时间
    OPE_SET_CALENDAR: (state, type) => {
      state.calendarDate = type
    },
    OPE_SET_Class2Active: (state, class2Active) => {
      state.class2Active = class2Active
    },
    // 详情页的时候的渠道id，当从首页过来的时候需要首页的渠道id，否则用自己的渠道id
    OPE_SET_DETAIL_CHANNEL: (state, detailChannel) => {
      state.detailChannel = detailChannel
    },
    OPE_SET_CHANNEL_QUOTA: (state, type) => {
      state.channelQuota = type
    },
    OPE_SET_AREA_CODE: (state, areaCode) => {
      state.areaCode = areaCode
    },
    OPE_SET_AREA_FLAG: (state, areaFlag) => {
      state.areaFlag = areaFlag
    }
  },
  actions: {
  }
}
export default ope



// WEBPACK FOOTER //
// ./src/store/modules/ope.js